/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import QRCode from 'qrcode';
/**
 * 根据地址生成二维码图片
 */

export function getQrcode(_x, _x2, _x3) {
  return _getQrcode.apply(this, arguments);
}

function _getQrcode() {
  _getQrcode = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee(qrcodeUrl, width, height) {
    var haha;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return QRCode.toDataURL(qrcodeUrl, {
              width: width,
              height: height
            });

          case 3:
            haha = _context.sent;
            return _context.abrupt("return", haha);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", '');

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));
  return _getQrcode.apply(this, arguments);
}

export function initCanvas(_x4) {
  return _initCanvas.apply(this, arguments);
}

function _initCanvas() {
  _initCanvas = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(_ref) {
    var canvas, qrcodeUrl, _ref$fillStyle, fillStyle, backgroundImg, texts;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            canvas = _ref.canvas, qrcodeUrl = _ref.qrcodeUrl, _ref$fillStyle = _ref.fillStyle, fillStyle = _ref$fillStyle === void 0 ? '#ffffff' : _ref$fillStyle, backgroundImg = _ref.backgroundImg, texts = _ref.texts;
            return _context3.abrupt("return", new Promise(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee2(resolve) {
                var rpx, dpr, img, qImg, qCode, onload;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        rpx = document.documentElement.clientWidth / 750;
                        dpr = 3; // 图片两倍绘制，放大不失真

                        canvas.width = 702 * rpx * dpr;
                        canvas.height = 840 * rpx * dpr;
                        img = new Image();
                        img.setAttribute('crossOrigin', 'anonymous');
                        qImg = new Image();
                        _context2.next = 9;
                        return getQrcode(qrcodeUrl, 240 * rpx, 240 * rpx);

                      case 9:
                        qCode = _context2.sent;
                        // 获取二维码
                        qImg.src = qCode;

                        onload = function onload(ignoreImg) {
                          var width = img.width,
                              height = img.height;
                          var ctx = canvas.getContext('2d');
                          ctx.fillStyle = fillStyle;
                          ctx.fillRect(0, 0, canvas.width, canvas.height);

                          if (ignoreImg !== 'ignoreImg') {
                            ctx.drawImage(img, 0, 0, canvas.width, height * (canvas.width / width)); // 在canvas画背景图原此尺寸即可
                          }

                          ctx.drawImage(qImg, 232 * rpx * dpr, 460 * rpx * dpr, 240 * rpx * dpr, 240 * rpx * dpr); // 在canvas 添加二维码

                          texts.forEach(function (txt, i) {
                            ctx.fillStyle = '#fff'; // canvas 文本颜色

                            ctx.font = "500 ".concat(28 * rpx * dpr, "px PingFangSC-Medium"); // canvas 文本属性

                            ctx.textAlign = 'center'; // 如居中，文本水平对齐方式

                            ctx.fillText(txt, 352 * rpx * dpr, (740 + i * 40) * rpx * dpr); // canvas 文本内容和位置定位
                          });
                          resolve(canvas.toDataURL('image/jpeg', 1.0));
                        };

                        if (backgroundImg) {
                          img.onload = onload;
                          img.src = backgroundImg;

                          img.onerror = function () {
                            onload('ignoreImg');
                          };
                        } else {
                          onload('ignoreImg');
                        }

                      case 13:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, this);
              }));

              return function (_x5) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 2:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));
  return _initCanvas.apply(this, arguments);
}